module.exports = __webpack_public_path__ + "static/img/暂无数据@3x.d84e32e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无数据@3x.png
// module id = 286
// module chunks = 363 364